import { auth } from "@/lib/auth/client";
import { LoaderCircle } from "lucide-react";
import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router";

type UserWithRole = {
  id: string;
  email: string;
  name: string | null;
  role?: string | null;
};

export function AdminGuard() {
  const { data: session, isPending } = auth.useSession();
  const navigate = useNavigate();

  const user = session?.user as UserWithRole | undefined;
  const canModerate = user?.role === "admin" || user?.role === "moderator";

  useEffect(() => {
    if (!isPending && !canModerate) {
      navigate("/dashboard", { replace: true });
    }
  }, [isPending, canModerate, navigate]);

  if (isPending) {
    return (
      <div className="flex min-h-[50vh] items-center justify-center">
        <div className="flex items-center gap-2 text-muted-foreground">
          <LoaderCircle className="size-5 animate-spin" />
          <span>Loading...</span>
        </div>
      </div>
    );
  }

  if (!canModerate) {
    return null;
  }

  return <Outlet />;
}
